import { printerStore, type PrinterStatus } from '@goshippo/print';

import {
  PRINT_STATUS_COMPLETED,
  PRINT_STATUS_FAILED,
  PRINT_STATUS_IN_FLIGHT,
} from '../constants/printStatus.const';
import { type PrintStatusOutcome } from '../types/printStatus.type';

export const classifyPrintStatus = (statusText: string): PrintStatusOutcome => {
  if (PRINT_STATUS_COMPLETED.has(statusText)) return 'completed';
  if (PRINT_STATUS_FAILED.has(statusText)) return 'failed';
  if (PRINT_STATUS_IN_FLIGHT.has(statusText)) return 'in_flight';
  // Unknown/unmapped status — surface as failed so the signal isn't lost.
  return 'failed';
};

export const getPrinterStatusSnapshot = (printerName: string): PrinterStatus | undefined => {
  const { statusByPrinter } = printerStore.getSnapshot();
  return statusByPrinter[printerName];
};
